module.exports = __webpack_public_path__ + "img/sblj-banner@2x.9edf7604.png";